import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { Pipeline } from '@vendasta/sales-common';
import { OrdersUrlFunction } from './opportunity';
import { Salesperson } from '@galaxy/types';
import { AccountSelectorServiceConfig } from '../accounts/account-selector/account-selector-api.service';
import { BusinessInfoService } from './opportunity-side-panel/business-service/opportunity-business.service';

export const SALES_UI_OPPORTUNITY_CONFIG_TOKEN = new InjectionToken<SalesUIOpportunityConfig>(
  'general dependency data for sales-ui opportunities',
);
export interface SalesUIOpportunityConfig
  extends AccountSelectorServiceConfig,
    SalesUIOpportunityDetailsConfig,
    SalesUICreateOpportunityConfig {
  businessInfoService: BusinessInfoService;
}

export const SALES_PERSON_ID_TOKEN: InjectionToken<Observable<string>> = new InjectionToken(
  'token for current sales person id to be used in the sales-ui opportunity service',
);

export const PIPELINES_TOKEN: InjectionToken<Observable<Pipeline[]>> = new InjectionToken(
  'token for current pipelines to be used in the sales-ui opportunity service',
);

export const SALES_UI_OPPORTUNITY_DETAILS_CONFIG_TOKEN = new InjectionToken<SalesUIOpportunityDetailsConfig>(
  'dependency data for the sales-ui opportunity details',
);

export interface SalesUIOpportunityDetailsConfig {
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  bypassQuantityRestrictions$: Observable<boolean>;
  pipelines$: Observable<Pipeline[]>;
  salespeople$: Observable<Salesperson[]>;
  getOrdersUrl: OrdersUrlFunction;
  canCreateOrders$: Observable<boolean>;
  showActivities$?: Observable<boolean>;
}

export const SALES_UI_CREATE_OPPORTUNITY_CONFIG_TOKEN = new InjectionToken<SalesUICreateOpportunityConfig>(
  'dependency data for the sales-ui create opportunity form',
);

export interface SalesUICreateOpportunityConfig {
  defaultCurrency$: Observable<string>;
  partnerId$: Observable<string>;
  marketId$: Observable<string>;
  bypassQuantityRestrictions$: Observable<boolean>;
  pipelines$: Observable<Pipeline[]>;
  salespeople$: Observable<Salesperson[]>;
  currentPipeline$: Observable<Pipeline>;
  salespersonId$: Observable<string>;
}

export const BUSINESS_INFO_SERVICE_TOKEN: InjectionToken<BusinessInfoService> = new InjectionToken<BusinessInfoService>(
  'token of service for retrieving business info to be used for sales-ui opportunities',
);

export const MARKET_ID_OVERRIDE_TOKEN: InjectionToken<string> = new InjectionToken<string>(
  'token for overriding the marketID that is usually provided in the sales UI config',
);
